import jsonFile from "../json/RouletteABI.json";
const RouletteABI = jsonFile;

export default RouletteABI;  